import { log10 } from "./helpers/common";
import { IAxisCreator, IAxisCreatorConfig, IAxisScale } from "./types";

const allowedBases = [1, 2, 3, 5, 10];

export class AxisCreator implements IAxisCreator {
	public config: IAxisCreatorConfig;

	constructor(private _data: any, conf: IAxisCreatorConfig = {}) {
		const chekedData = [];
		for (const item of this._data) {
			if (typeof item === "number") {
				chekedData.push(item);
			}
			if (typeof item === "string" && !isNaN(parseFloat(item))) {
				chekedData.push(parseFloat(item));
			}
		}
		const defaults: IAxisCreatorConfig = {
			min: Math.min(...chekedData),
			max: Math.max(...chekedData),
			maxTicks: this._data.length < 20 ? this._data.length : 20,
		};
		this.config = { ...defaults, ...conf };
		if (this.config.padding) {
			this._addPadding();
		}
	}

	getScale(): IAxisScale {
		const steps = this.config.log ? this._logSteps() : this._calculateSteps(this._getStep());
		return {
			min: steps[0],
			max: steps[steps.length - 1],
			steps,
		};
	}

	private _getStep(): number {
		const ticks = this.config.maxTicks;
		const dif = this.config.max - this.config.min;
		const exponent = Math.floor(log10(dif / ticks));
		const step = 10 ** exponent || 1;
		const rawBase = dif / step / ticks;
		const nearestBase = allowedBases[[...allowedBases, rawBase].sort((a, b) => a - b).indexOf(rawBase)];
		return nearestBase * step;
	}

	private _calculateSteps(step: number): number[] {
		const firstIndex = Math.floor(this.config.min / step);
		const lastIndex = Math.ceil(this.config.max / step);
		const steps = [];
		for (let i = this.config.type === "radial" ? firstIndex - 1 : firstIndex; i <= lastIndex; i++) {
			let currentStep = step * i;
			if (Math.floor(currentStep) !== currentStep) {
				currentStep = parseFloat(currentStep.toFixed(8));
			}
			steps.push(currentStep);
		}
		return steps;
	}

	private _logSteps(): number[] {
		const steps = [];
		if (this.config.min < 0) {
			const negativeExponent = Math.ceil(log10(-this.config.min));
			for (let i = negativeExponent; i > 0; i--) {
				steps.push(-(10 ** i));
			}
			steps.push(0);
		}

		if (this.config.max > 0) {
			const positiveExponent = Math.ceil(log10(this.config.max));
			for (let i = 0; i <= positiveExponent; i++) {
				steps.push(10 ** i);
			}
		}
		return steps;
	}

	private _addPadding(): void {
		this.config.min -= this.config.padding;
	}
}
